"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getNearLocation = exports["default"] = void 0;
var _getDomPositionInfo3 = _interopRequireDefault(require("./getDomPositionInfo.js"));
var _type = require("./type.js");
// @ts-check

/**
 * @param {number} left
 * @param {number} top
 * @param {number} width
 * @param {number} height
 * @returns {Coordinate}
 */
var calDomCenter = function calDomCenter(left, top, width, height) {
  var xy = {
    x: left + Math.floor(width / 2),
    y: top + Math.floor(height / 2)
  };
  return xy;
};

/**
 * @param {HTMLElement} dom
 * @returns {Coordinate}
 */
var getDomCenter = function getDomCenter(dom) {
  var _getDomPositionInfo;
  var _ref = ((_getDomPositionInfo = (0, _getDomPositionInfo3["default"])(dom)) === null || _getDomPositionInfo === void 0 ? void 0 : _getDomPositionInfo.domInfo) || {},
    left = _ref.left,
    top = _ref.top,
    width = _ref.width,
    height = _ref.height;
  var domCenter = calDomCenter(left, top, width, height);
  return domCenter;
};

/**
 * @param {Coordinate} center
 * @param {Coordinate} floatInfo
 * @returns {NearLocType}
 */
var getNearLocation = exports.getNearLocation = function getNearLocation(center, floatInfo) {
  var loc = {
    center: false,
    centerCenter: false,
    top: false,
    bottom: false,
    left: false,
    right: false
  };
  if (floatInfo.x > center.x) {
    loc.right = true;
  } else if (floatInfo.x < center.x) {
    loc.left = true;
  } else {
    loc.center = true;
  }
  if (floatInfo.y > center.y) {
    loc.bottom = true;
  } else if (floatInfo.y < center.y) {
    loc.top = true;
  } else {
    loc.center = true;
  }
  if (loc.center) {
    if (!loc.top && !loc.bottom && !loc.left && !loc.right) {
      loc.centerCenter = true;
    }
  }
  return loc;
};

/**
 * @param {HTMLElement} targetEl
 * @param {HTMLElement|Coordinate} floatElOrFloatXY
 * @returns {NearLocType}
 */
var nearWhere = function nearWhere(targetEl, floatElOrFloatXY) {
  var tarCenter = getDomCenter(targetEl);
  var floatXY;
  var floatEl = /**@type HTMLElement*/floatElOrFloatXY;
  if (floatEl.nodeName) {
    var _getDomPositionInfo2;
    var floatElInfo = ((_getDomPositionInfo2 = (0, _getDomPositionInfo3["default"])(floatEl)) === null || _getDomPositionInfo2 === void 0 ? void 0 : _getDomPositionInfo2.domInfo) || {
      top: 0,
      left: 0
    };
    floatXY = {
      x: floatElInfo.left,
      y: floatElInfo.top
    };
  }
  if (null == floatXY) {
    floatXY = /**@type Coordinate*/floatElOrFloatXY;
  }
  return getNearLocation(tarCenter, floatXY);
};
var _default = exports["default"] = nearWhere;